export default {"src":"/_next/static/media/PXD.64d0d0c4.svg","height":18,"width":18};